import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CartService } from '../../shared/services/cart.service';
import { SelfserviceService } from '../../shared/services/selfservice.service';

import { ProductOrder } from '../../shared/models/product-order';
import { SsOrder, SsOrderItem } from '../../shared/models/selfservice';
import { faXmark } from '../../icons';
@Component({
    selector: 'app-sscart',
    templateUrl: './sscart.component.html',
    styleUrls: ['./sscart.component.scss'],
    standalone: false
})
export class SscartComponent implements OnInit {
    faXmark = faXmark;
  // Set by the parent while a place_order request is outstanding, so the
  // ENVIAR button can be disabled and a double-tap can't emit two orders.
  @Input() sending: boolean = false;
  @Output() onSend: EventEmitter<SsOrder> = new EventEmitter();
  @Output() onClose: EventEmitter<string> = new EventEmitter();

  constructor(public cart: CartService, private ssServ: SelfserviceService) { }

  ngOnInit(): void {
    ProductOrder.setArrayAdditionalData(this.cart.cart_items);
  }
  removeItem(po: ProductOrder) {
    this.cart.removeItem(po);
  }
  exit(reason: string) {
    this.onClose.emit(reason);
  }
  send() {
    if(this.sending) {
      return;
    }
    let order: SsOrder = this._convertOrder(this.cart.cart_items);
    this.onSend.emit(order);
  }

  private _convertOrder(items: ProductOrder[]): SsOrder {
    let order: SsOrder = <SsOrder> {
      id: -Math.floor(Math.random() * 1000000),
      items: [],
      created_at: new Date().toISOString()
    };

    for(let item of items) {
      order.items.push(<SsOrderItem>{
        product_local_id: item.product.local_id,
        quantity: item.quantity,
        notes_attributes: item.notes_attributes,
        product_name: item.product.name,
        product_price: item.product.price,
        poptional_selections: item.poptional_selections
      });
    }

    return order;
  }
}
